// HCON약관사용시점코드
export enum HcTncUsePntmCd {
  MEMBER_JOIN = "1001",                    /* 회원가입 */
  MEMBER_ORDER = "1002",                   /* 회원 주문 */
  MEMBER_ACCOUNT_REGISTER = "1003",        /* 회원 계좌 등록 */
  MEMBER_SENDNO_REGISTER = "1004",         /* 회원 발신번호 등록 */
  MEMBER_RCVNO_REGISTER = "1005",          /* 회원 수신자번호 등록 */
  MEMBER_PIN_PUBLICATION_REQUEST = "1006", /* 회원 PIN발행요청 */
  MEMBER_PIN_PUBLICATION_ORDER = "1007",   /* 회원 PIN발행요청 */
  DISPLAY_MAIN = "1008",                   /* 전시메인 */
}

// HCON약관종류코드
export enum HcTncKndCd {
  KND_1001 = "1001", /* 서비스 이용약관 */
  KND_1002 = "1002", /* 전자금융거래이용약관 */
  KND_1003 = "1003", /* 개인정보처리방침 */
  KND_1004 = "1004", /* API연동발송 이용약관 */
  KND_1005 = "1005", /* 문자메시지 이용약관 */
  KND_1006 = "1006", /* 개인정보 수집 및 이용 */
  KND_1007 = "1007", /* 개인정보 제3자 제공동의 */
  KND_1008 = "1008", /* 전자금융거래 이용 약관 */
  KND_1009 = "1009", /* 약정체결의 성립 */
  KND_1010 = "1010", /* 유효기간 연장 및 환불, 주문 취소 등 */
  KND_1011 = "1011", /* 마케팅 수신동의 */
  KND_1012 = "1012", /* 14세 이상 동의 */
  KND_1013 = "1013", /* PIN발행 서비스 동의 */
  KND_1014 = "1014", /* 재판매 등 부정사용 및 브랜드사 상표 무단 사용 불가 */
  KND_1015 = "1015", /* 주문내용 및 결제조건 확인 및 구매 동의 */
  KND_1016 = "1016", /* 수신자 정보 자동파기 */
}